export const products = [
  {
    attributes: {
      name: 'Center Gold Tray - White Gold  16"',
      slug: "center-gold-tray-white-gold-16",
      description:
        '<p>Add a touch of elegance to your décor with this stunning <strong>White &amp; Gold Center Tray</strong>, featuring an intricate <strong>artistic golden design</strong> at its heart. Measuring 16 inches and &nbsp;12" width, &nbsp;this tray is the perfect blend of modern luxury and timeless sophistication in glass and wood.</p><p>The smooth white surface contrasts beautifully with the bold, golden accents, making it ideal for serving or as a decorative centerpiece. The <strong>golden artistic pattern</strong> in the center exudes charm and craftsmanship, drawing attention to its exquisite details.</p><p>Whether used for entertaining guests or enhancing your home décor, this tray radiates opulence and is a perfect statement piece for any occasion.</p>',
      MRP: 3750,
      sellingPrice: 2655,
      category: {
        data: {
          attributes: {
            name: "Tray",
            slug: "tray",
          },
        },
      },
      stock: 1,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '16"',
            slug: "16",
          },
        },
      },
      sku: "CGTYWG16",
      code: "RB21",
      dimensions: {
        width: '12"',
        height: '1.5"',
        length: '16"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Wooden Tray white gold",
              url: "/images/products/Wooden_Tray_white_gold_1c3ce62282.webp",
              size: 125.22,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Deep Shovel Platter - White Gold",
      slug: "deep-shovel-platter-white-gold",
      description:
        '<p>Elevate your dining experience with the <strong>Deep Shovel Platter</strong> in elegant <strong>white and gold</strong>. Measuring <strong>15 inches in length and 9 inches in width</strong>, this sophisticated serving piece is perfect for presenting snacks, appetizers, and delicacies in style. Its unique shovel shape offers both aesthetic appeal and practicality, allowing for easy serving and generous portions. Crafted from premium handcrafted glass materials, the white surface is complemented by luxurious gold accents, making it a standout addition to any table setting. Ideal for entertaining or special occasions, this platter seamlessly blends functionality with refined design.</p><p>key features&nbsp;</p><ul><li><strong>Dimensions</strong>: 15" length x 9" width</li><li>Elegant white and gold color scheme</li><li>Deep, shovel-shaped design for convenient serving</li><li>Perfect for snacks, appetizers, and delicacies</li><li>Durable and easy to clean</li><li>Make your dining table shine with this stylish and versatile serving platter!</li></ul>',
      MRP: 3999,
      sellingPrice: 2500,
      category: {
        data: {
          attributes: {
            name: "Shovel",
            slug: "shovel",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "SPDSWG15",
      code: "RB10",
      dimensions: {
        width: '9"',
        height: "",
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Deep Shovel Platter - White Gold1",
              url: "/images/products/Deep_Shovel_Platter_White_Gold_64f1724065.webp",
              size: 125.03,
            },
          },
          {
            attributes: {
              alternativeText: "Deep Shovel Platter - White Gold0",
              url: "/images/products/Deep_Shovel_Platter_White_Gold_46ead8398e.webp",
              size: 129.44,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Flower T - Light (Midnight Black)",
      slug: "flower-t-light-midnight-black",
      description:
        "<p>This elegant <strong>Flower-Shaped Glass Bowl</strong> &nbsp;T light is the perfect blend of art and functionality. Designed to mimic the gentle curves of flower petals, each petal segment alternates between frosted light and dark tones, creating a beautiful contrast. Crafted from premium glass, the bowl features a textured surface that adds a touch of sophistication to any space. Whether used as a centerpiece or for serving, this bowl makes a stunning statement in modern and minimalist interiors.</p><ul><li><p><strong>Material</strong>: Glass</p><p>&nbsp;</p></li></ul>",
      MRP: 950,
      sellingPrice: 600,
      category: {
        data: {
          attributes: {
            name: "T-Light",
            slug: "t-light",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Midnight Black",
            slug: "midnight-black",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '7"',
            slug: "7",
          },
        },
      },
      sku: "FLRTLBLK",
      code: "RB42",
      dimensions: {
        width: '7"',
        height: '2"',
        length: '7"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/pixelcut_export_50_56bc89cdf4.jpeg",
              size: 400.3,
            },
          },
          {
            attributes: {
              alternativeText: "flower-t-midnight-black",
              url: "/images/products/flower_t_black_55eefb9ca1.webp",
              size: 43.04,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Flower T - Lights (Green)",
      slug: "flower-green",
      description:
        "<p>This elegant <strong>Flower-Shaped Glass Bowl</strong> &nbsp;T light is the perfect blend of art and functionality. Designed to mimic the gentle curves of flower petals, each petal segment alternates between frosted light and dark tones, creating a beautiful contrast. Crafted from premium glass, the bowl features a textured surface that adds a touch of sophistication to any space. Whether used as a centerpiece or for serving, this bowl makes a stunning statement in modern and minimalist interiors.</p><ul><li><p><strong>Material</strong>: Glass</p><p>&nbsp;</p></li></ul>",
      MRP: 950,
      sellingPrice: 600,
      category: {
        data: {
          attributes: {
            name: "T-Light",
            slug: "t-light",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Green",
            slug: "green",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '7"',
            slug: "7",
          },
        },
      },
      sku: "FLRTLGRE",
      code: "RB41",
      dimensions: {
        width: '7"',
        height: '2"',
        length: '7"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/Whats_App_Image_2024_10_03_at_22_32_34_a5835c5bbb.jpeg",
              size: 107.75,
            },
          },
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/Whats_App_Image_2024_10_03_at_22_32_34_1_5dc51e210c.jpeg",
              size: 107.75,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Fruit Bowl",
      slug: "fruit-bowl",
      description:
        '<p>This exquisite <strong>glass fruit bowl</strong>, measuring <strong>12" x 12"</strong>, is a true masterpiece of design and craftsmanship. The bowl features a striking combination of a <strong>translucent glass base</strong> and an intricately detailed <strong>gold-accented rim</strong>. The radiant gold border, with its textured, organic finish, adds an element of luxury and refinement, making this piece both functional and decorative.</p><p>Perfect for displaying fresh fruits, this bowl enhances the natural colors and textures of its contents, making it an ideal centerpiece for elegant dining settings or as a statement piece in your home décor. Whether used for serving or simply as an objet d’art, this unique glass fruit bowl effortlessly blends modern sophistication with timeless elegance.</p><hr>',
      MRP: 3999,
      sellingPrice: 3000,
      category: {
        data: {
          attributes: {
            name: "Fruit Bowl",
            slug: "fruit-bowl",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "Rbfb12",
      code: "RB42",
      dimensions: {
        width: '12"',
        height: '2"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "fruit bowl",
              url: "/images/products/FRUIT_BOWL_W_and_G_77d87b41d3.webp",
              size: 12.6,
            },
          },
          {
            attributes: {
              alternativeText: "fruit bowl",
              url: "/images/products/SPLASH_BOWL_WITH_STAND_83ca4c78c3.webp",
              size: 16.92,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter - Gold Leaf",
      slug: "lazy-susan-round-platter-gold-leaf-large",
      description:
        "<p>Introducing Lazy Susan handcrafted glass platter in attractive spiral design. The rotating platter adds to the overall style quotient and presentation of your delicacies. The platter can be rotated with with just one finger on the dinning or coffee table</p>",
      MRP: 4999,
      sellingPrice: 3650,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Autumn",
            slug: "autumn",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "LSGL15",
      code: "RB8",
      dimensions: {
        width: '15"',
        height: '3"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter - Gold Leaf0",
              url: "/images/products/Lazy_Susan_Round_Platter_Gold_Leaf_d2c0403873.webp",
              size: 63.51,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter - Gold Leaf",
      slug: "lazy-susan-round-platter-gold-leaf-medium",
      description:
        "Introducing Lazy Susan  handcrafted glass platter in attractive spiral design. The rotating platter adds to the overall style quotient  and presentation of your delicacies.  The platter can be rotated with with just one finger on the dinning or coffee table ",
      MRP: 4375,
      sellingPrice: 3300,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Autumn",
            slug: "autumn",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "LSGL12",
      code: "RB7",
      dimensions: {
        width: '12"',
        height: '3"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter - Gold Leaf0",
              url: "/images/products/Lazy_Susan_Round_Platter_Gold_Leaf_d2c0403873.webp",
              size: 63.51,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter - White Gold",
      slug: "lazy-susan-round-platter-white-gold-medium",
      description:
        '<p>Introducing our stunning <strong>White Gold Lazy Susan Revolving Glass Platter</strong> – a perfect fusion of elegance and functionality. With a diameter of 12", this sleek glass platter features a white gold-finished base, offering a luxurious touch to any dining or serving setup. The smooth 360-degree rotation ensures easy access to appetizers, desserts, or condiments for all your guests, making it ideal for both everyday use and special occasions.</p><p>Crafted for durability and style, this revolving platter adds sophistication to your table while enhancing the dining experience with convenience. A must-have centerpiece for entertaining in style!</p>',
      MRP: 4375,
      sellingPrice: 3300,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "LSWG12",
      code: "RB1",
      dimensions: {
        width: '12"',
        height: '3"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter - White Gold0",
              url: "/images/products/Lazy_Susan_Round_Platter_White_Gold_49fc3acb20.webp",
              size: 120.23,
            },
          },
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/pixelcut_export_10_b5f230db14.jpeg",
              size: 710.96,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter - White Gold",
      slug: "lazy-susan-round-platter-white-gold-large",
      description:
        '<p>Introducing our stunning <strong>White Gold Lazy Susan Revolving Glass Platter</strong> – a perfect fusion of elegance and functionality. With a diameter of 15", this sleek glass platter features a white gold-finished base, offering a luxurious touch to any dining or serving setup. The smooth 360-degree rotation ensures easy access to appetizers, desserts, or condiments for all your guests, making it ideal for both everyday use and special occasions.</p><p>Crafted for durability and style, this revolving platter adds sophistication to your table while enhancing the dining experience with convenience. A must-have centerpiece for entertaining in style!</p>',
      MRP: 4999,
      sellingPrice: 3650,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "LSWG15",
      code: "RB2",
      dimensions: {
        width: '15"',
        height: '3"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/lazy_susan_white_gold_15_in_42e08a4619.jpeg",
              size: 65.07,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter- Black Gold",
      slug: "lazy-susan-round-platter-black-gold-medium",
      description:
        '<p>Introducing our stunning Black<strong> Gold Lazy Susan Revolving Glass Platter</strong> – a perfect fusion of elegance and functionality. With a diameter of 12", this sleek glass platter features a Black gold-finished base, offering a luxurious touch to any dining or serving setup. The smooth 360-degree rotation ensures easy access to appetizers, desserts, or condiments for all your guests, making it ideal for both everyday use and special occasions.</p><p>Crafted for durability and style, this revolving platter adds sophistication to your table while enhancing the dining experience with convenience. A must-have centerpiece for entertaining in style!</p>',
      MRP: 4375,
      sellingPrice: 3300,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "LSBG12",
      code: "RB5",
      dimensions: {
        width: '12"',
        height: '3"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter- Black Gold0",
              url: "/images/products/Lazy_Susan_Round_Platter_Black_Gold_58d8306665.webp",
              size: 260.23,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter- Black Gold",
      slug: "lazy-susan-round-platter-black-gold-large",
      description:
        '<p>Introducing our stunning Black<strong> Gold Lazy Susan Revolving Glass Platter</strong> – a perfect fusion of elegance and functionality. With a diameter of 15", this sleek glass platter features a white gold-finished base, offering a luxurious touch to any dining or serving setup. The smooth 360-degree rotation ensures easy access to appetizers, desserts, or condiments for all your guests, making it ideal for both everyday use and special occasions.</p><p>Crafted for durability and style, this revolving platter adds sophistication to your table while enhancing the dining experience with convenience. A must-have centerpiece for entertaining in style!</p>',
      MRP: 4999,
      sellingPrice: 3500,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "LSBG15",
      code: "RB6",
      dimensions: {
        width: '15"',
        height: '3"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/lazy_susan_black_gold_15_angle_2_0b04612b00.jpeg",
              size: 319.25,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter- Evil Eye",
      slug: "lazy-susan-round-platter-evil-eye",
      description:
        "<p>Add a touch of mystique and elegance to your dining experience with our 12-inch <strong>Lazy Susan</strong> featuring a striking <strong>Evil Eye</strong> design. Crafted for both style and functionality, this rotating platter is perfect for serving appetizers, desserts, or condiments with ease. The bold and protective <strong>Evil Eye</strong> motif not only adds a unique visual appeal but also serves as a symbol of good luck and protection for your home. Made from durable, high-quality materials, this Lazy Susan is a practical yet stylish addition to any kitchen or dining table. Ideal for entertaining or everyday use.</p><p>Key features</p><ul><li>360 degrees rotation</li><li>Smooth 360-degree rotation</li><li>Eye-catching <strong>Evil Eye</strong> design</li><li>Durable and easy to clean</li><li>Perfect for serving food, snacks, or condiments</li><li>Make a statement at your next gathering with this unique and functional piece!</li></ul><p>&nbsp;</p>",
      MRP: 4375,
      sellingPrice: 3300,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 1,
      color: {
        data: {
          attributes: {
            name: "Blue",
            slug: "blue",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "LSEE12",
      code: "RB9",
      dimensions: {
        width: '12"',
        height: '3"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter- Evil Eye0",
              url: "/images/products/Lazy_Susan_Round_Platter_Evil_Eye_aace86a2c8.webp",
              size: 159.08,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter- Peach Silver",
      slug: "lazy-susan-round-platter-peach-silver-large",
      description:
        '<p>Introducing our stunning Peach Silver <strong>Lazy Susan Revolving Glass Platter</strong> – a perfect fusion of elegance and functionality. With a diameter of 15", this sleek glass platter features a white gold-finished base, offering a luxurious touch to any dining or serving setup. The smooth 360-degree rotation ensures easy access to appetizers, desserts, or condiments for all your guests, making it ideal for both everyday use and special occasions.</p><p>Crafted for durability and style, this revolving platter adds sophistication to your table while enhancing the dining experience with convenience. A must-have centerpiece for entertaining in style!</p>',
      MRP: 4999,
      sellingPrice: 3650,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Peach Silver",
            slug: "peach-silver",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "LSRPS15",
      code: "RB4",
      dimensions: {
        width: '15"',
        height: '3"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter- Peach Silver0",
              url: "/images/products/Lazy_Susan_Round_Platter_Peach_Silver_5567d3e74e.webp",
              size: 58.9,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Lazy Susan Round Platter- Peach Silver",
      slug: "lazy-susan-round-platter-peach-silver-medium",
      description:
        "Introducing Lazy Susan  handcrafted glass platter in attractive spiral design. The rotating platter adds to the overall style quotient  and presentation of your delicacies.  The platter can be rotated with with just one finger on the dinning or coffee table ",
      MRP: 4375,
      sellingPrice: 3300,
      category: {
        data: {
          attributes: {
            name: "Lazy Susan",
            slug: "lazy-susan",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Peach Silver",
            slug: "peach-silver",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "LSRPS12",
      code: "RB3",
      dimensions: {
        width: '12"',
        height: '3"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Lazy Susan Round Platter- Peach Silver0",
              url: "/images/products/Lazy_Susan_Round_Platter_Peach_Silver_5567d3e74e.webp",
              size: 58.9,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Leaf platter - Black Gold , Wooden Stand",
      slug: "leaf-platter-black-gold-wooden-stand",
      description:
        '<p>Elevate your hosting experience with this sleek and modern <strong>Black &amp; Gold Cheese Platter</strong>. Uniquely shaped to impress, this platter features a striking combination of matte black and lustrous gold accents, making it the perfect centerpiece for any gathering.</p><p>Crafted from premium materials, the platter comes with a sturdy <strong>wooden stand</strong>, adding warmth and elegance to the presentation. Its generous dimensions (22.5" x 7.2" x 3.3") provide ample space to artfully display a variety of cheeses, fruits, and charcuterie.</p><p>Whether for intimate gatherings or grand events, this platter brings sophistication and style to your table, blending contemporary design with functional appeal.</p>',
      MRP: 4999,
      sellingPrice: 3999,
      category: {
        data: {
          attributes: {
            name: "Platter",
            slug: "platter",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '22.5"',
            slug: "225",
          },
        },
      },
      sku: "LPCHBG22",
      code: "RB20",
      dimensions: {
        width: "7.2",
        height: '3.3"',
        length: "22.5",
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "leaf platter with wooden stand",
              url: "/images/products/leaf_platter_with_wooden_stand_angle_cf769e5e0a.webp",
              size: 182.17,
            },
          },
          {
            attributes: {
              alternativeText: "leaf platter with wooden stand",
              url: "/images/products/Leaf_platter_d23dbf3333.webp",
              size: 166.71,
            },
          },
          {
            attributes: {
              alternativeText: "leaf platter without stand",
              url: "/images/products/leaf_platter_without_stand_25edec0c6d.webp",
              size: 78.58,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Mini Shovel Platter - Black Gold",
      slug: "mini-shovel-platter-black-gold",
      description:
        '<p>Introducing the <strong>Deep Shovel Platter</strong> in striking <strong>black and gold</strong>, designed to enhance your dining experience. Measuring <strong>15 inches in length and 9 inches in width</strong>, this sophisticated serving piece is perfect for showcasing an array of snacks and delicacies. Its deep, shovel-like shape allows for generous servings, making it ideal for everything from appetizers to desserts. The bold black surface is beautifully complemented by luxurious gold accents, creating a stunning contrast that adds elegance to any table setting. Whether for formal gatherings or casual get-togethers, this platter effortlessly combines style and functionality.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 15" length x 9" width</li><li>Elegant black and gold color scheme</li><li>Deep, shovel-shaped design for easy serving</li><li>Perfect for a variety of snacks and delicacies</li><li>Durable and easy to clean</li></ul><p>Elevate your serving style with this eye-catching and versatile platter!</p>',
      MRP: 3499,
      sellingPrice: 2000,
      category: {
        data: {
          attributes: {
            name: "Shovel",
            slug: "shovel",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "SPMSBG15",
      code: "RB13",
      dimensions: {
        width: '9"',
        height: '2.5"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Mini Shovel Platter - Black Gold0",
              url: "/images/products/Mini_Shovel_Platter_Black_Gold_c33bcbdf7b.webp",
              size: 78.16,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Mini Shovel Platter - White Gold",
      slug: "mini-shovel-platter-white-gold",
      description:
        '<p>Serve your favorite dishes in style with the <strong>Deep Shovel Platter</strong> featuring a sleek <strong>white and gold</strong> design and a <strong>long wooden handle</strong>. Measuring <strong>12.4 inches in length and 5.6 inches in width</strong>, this unique platter is perfect for presenting a variety of delicacies like <strong>momos, pizza, pastries, spring rolls</strong>, and more. The deep, shovel-like shape and ergonomic wooden handle make it easy to carry and serve, while its elegant finish adds a touch of sophistication to your table. Whether you\'re hosting a gathering or simply elevating everyday meals, this versatile platter combines functionality with striking design.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 12.4" length x 5.6" width</li><li>Elegant white and gold finish with a natural wooden handle</li><li>Deep, shovel design for easy serving</li><li>Ideal for pizza, pastries, spring rolls, and other snacks</li><li>Durable, stylish, and easy to clean</li></ul><p>Add a contemporary twist to your serving collection with this functional and eye-catching platter!</p>',
      MRP: 3499,
      sellingPrice: 2250,
      category: {
        data: {
          attributes: {
            name: "Shovel",
            slug: "shovel",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: "12.3",
            slug: "123",
          },
        },
      },
      sku: "SPMSWG15",
      code: "RB12",
      dimensions: {
        width: '5.6"',
        height: '1.5"',
        length: '12.4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Mini Shovel Platter - White Gold0",
              url: "/images/products/Mini_Shovel_Platter_White_Gold_88bdf32700.webp",
              size: 121.38,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Nachos Platter Black Gold",
      slug: "nachos-platter-black-gold",
      description:
        '<div dir="auto">Elevate your snacking experience with our 21" x 8" Glass Nacho Platter in black and gold matt finish. &nbsp;Designed for style and functionality, this sleek and spacious platter beautifully showcases your favorite nachos. Its generous size accommodates plenty of chips, melted cheese, and toppings, making it perfect for gatherings and parties. Crafted from durable, heat-resistant glass, it’s easy to clean and complements any table setting. Serve up a deliciously fun treat with this elegant nacho platter!</div><div class="yj6qo">&nbsp;</div><div class="adL" dir="auto"><br>&nbsp;</div>',
      MRP: 3999,
      sellingPrice: 2600,
      category: {
        data: {
          attributes: {
            name: "Platter",
            slug: "platter",
          },
        },
      },
      stock: 1,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '21"',
            slug: "21",
          },
        },
      },
      sku: "NACHPLTR",
      code: "RB39",
      dimensions: {
        width: '8"',
        height: "",
        length: '21"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Nachos Platter Black Gold0",
              url: "/images/products/Nachos_Platter_Black_Gold_aaf1d07024.webp",
              size: 134.49,
            },
          },
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/NACHO_PLATTER_copy_3_1_eaf15ab822.jpg",
              size: 41.29,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Pebbles Platter - Black Gold Large",
      slug: "pebbles-platter-black-gold-large",
      description:
        '<p>Make a statement with the <strong>Pebbles Platter</strong> in sleek <strong>black</strong> with luxurious <strong>gold-edged</strong> detailing. Measuring <strong>15 x 10 x 1.5 inches</strong>, this elegantly crafted platter is perfect for serving an array of snacks, appetizers, or desserts. Its unique pebble-inspired texture combined with the gold trim on the edges offers a modern, sophisticated touch, ensuring it stands out on any dining table.</p><p>The set includes a matching spatula for effortless serving, adding both practicality and style to your presentation. Crafted from high-quality materials, this platter is durable, easy to clean, and ideal for both casual and formal occasions.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 15" x 10" x 1.5"</li><li>Stylish black design with gold-edged accents</li><li>Unique pebble-inspired texture</li><li>Includes a matching spatula for easy serving</li><li>Ideal for serving snacks, appetizers, or desserts</li><li>Durable and easy to clean</li></ul><p>Elevate your dining experience with this chic and versatile platter, perfect for making a lasting impression!</p>',
      MRP: 5249,
      sellingPrice: 3500,
      category: {
        data: {
          attributes: {
            name: "Pebbles",
            slug: "pebbles",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "PPBGPL",
      code: "RB16",
      dimensions: {
        width: '10"',
        height: '1.5"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Pebbles Platter - Black Gold Large0",
              url: "/images/products/Pebbles_Platter_Black_Gold_Large_2ab974ab93.webp",
              size: 41.52,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Pebbles Platter - Black Gold Medium",
      slug: "pebbles-platter-black-gold-medium",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="27ed73b6-1caf-4626-bbc7-8905803f2b09" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Add a touch of sophistication to your table with the <strong>Pebbles Platter</strong> in elegant <strong>black with gold-edged detailing</strong>. Measuring <strong>12 x 7.0 inches</strong>, this platter is designed with a sleek, pebble-inspired texture, perfect for serving snacks, appetizers, or desserts with style. The luxurious gold accents on the edges provide a striking contrast against the black, making it a standout piece for any dining occasion.</p><p>Accompanied by a matching spatula for easy serving, this platter is not only visually appealing but also practical. Crafted from durable materials, it\'s easy to clean and ideal for both casual gatherings and formal events.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 12" x 7.0"</li><li>Elegant black finish with gold-edged detailing</li><li>Pebble-inspired texture for a unique look</li><li>Includes a matching spatula for easy serving</li><li>Perfect for snacks, appetizers, or desserts</li><li>Durable and easy to clean</li></ul><p>Elevate your serving style with this chic and functional platter set, perfect for any occasion!</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 4450,
      sellingPrice: 2850,
      category: {
        data: {
          attributes: {
            name: "Pebbles",
            slug: "pebbles",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '12"',
            slug: "12",
          },
        },
      },
      sku: "PPBGPM",
      code: "RB17",
      dimensions: {
        width: '7"',
        height: '1.5"',
        length: '12"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Pebbles Platter - Black Gold Medium0",
              url: "/images/products/Pebbles_Platter_Black_Gold_Medium_4ed169a98f.webp",
              size: 44.35,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Pebbles Platter - Black Gold Set of 3 ",
      slug: "pebbles-platter-black-gold-set-of-3",
      description:
        "<p>Enhance your serving experience with our <strong>Pebbles Platter Set</strong>, which includes three beautifully designed platters and a matching spatula. Each platter features a unique pebble-inspired texture that adds an organic touch to your dining table, making them perfect for both casual gatherings and elegant occasions. The set includes varying sizes to accommodate everything from appetizers to desserts, providing versatility for any event.</p><p>The accompanying spatula ensures effortless serving, allowing you to present your culinary creations with ease. Made from high-quality materials, these platters are durable and easy to clean, making them a practical addition to your kitchenware. Whether you’re hosting a party or enjoying a cozy family meal, the <strong>Pebbles Platter Set</strong> will elevate your dining presentation.</p><p><strong>Features:</strong></p><ul><li>Set includes 3 platters in varying sizes and a spatula</li><li>Unique pebble-inspired texture for a natural look</li><li>Perfect for serving appetizers, snacks, or desserts</li><li>Durable and easy to clean</li><li>Ideal for both casual and formal occasions</li></ul><p>Make every meal memorable with this stylish and functional platter set!</p>",
      MRP: 11500,
      sellingPrice: 8000,
      category: {
        data: {
          attributes: {
            name: "Pebbles",
            slug: "pebbles",
          },
        },
      },
      stock: 1,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "PPBGSET3",
      code: "RB15",
      dimensions: {
        width: '10"',
        height: '1.6"',
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Pebbles Platter - Black Gold Set of 3 0",
              url: "/images/products/Pebbles_Platter_Black_Gold_Set_of_3_225a4e4c54.webp",
              size: 56.9,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Pebbles Platter - Black Gold Small",
      slug: "pebbles-platter-black-gold-small",
      description:
        '<p>Serve in style with the <strong>Pebbles Platter</strong>, featuring a chic <strong>black finish</strong> and luxurious <strong>gold-edged</strong> detailing. Measuring <strong>8 x 7 x 1.5 inches</strong>, this compact platter is perfect for serving smaller portions of snacks, appetizers, or desserts, making it ideal for intimate gatherings or elegant displays. The distinctive pebble-inspired texture and sleek gold trim offer a modern and sophisticated look.</p><p>This set includes a matching spatula for easy serving, ensuring both functionality and style. Crafted from high-quality materials, the platter is durable and easy to clean, making it suitable for both casual and formal occasions.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 8" x 7" x 1.5"</li><li>Elegant black finish with gold-edged accents</li><li>Pebble-inspired texture for a modern design</li><li>Comes with a matching spatula for effortless serving</li><li>Ideal for serving small snacks, appetizers, or desserts</li><li>Durable and easy to clean</li></ul><p>Perfect for any dining occasion, this stylish platter adds a touch of elegance to your table setting!</p>',
      MRP: 2799,
      sellingPrice: 1500,
      category: {
        data: {
          attributes: {
            name: "Pebbles",
            slug: "pebbles",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black gold",
            slug: "black-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '8"',
            slug: "8",
          },
        },
      },
      sku: "PPBGPS",
      code: "RB18",
      dimensions: {
        width: '7"',
        height: '1.5"',
        length: '8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Pebbles Platter - Black Gold Small0",
              url: "/images/products/Pebbles_Platter_Black_Gold_Small_5e0175f631.webp",
              size: 18.38,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Shovel Serving Platter - White Gold Rectangle",
      slug: "shovel-serving-platter-white-gold-rectangle",
      description:
        '<p>Serve in style with our <strong>Shovel Serving Platter</strong> in elegant <strong>white and gold</strong>. Measuring <strong>15 x 9 inches</strong>, this rectangular platter is perfect for displaying a variety of snacks and appetizers. Its unique shovel shape offers a contemporary twist while providing ample space for your favorite treats. The sophisticated white surface is beautifully accented with gold, making it an eye-catching centerpiece for any gathering. Whether you’re hosting a formal dinner or a casual get-together, this platter is both functional and stylish, elevating your dining experience.</p><p><strong>Features:</strong></p><ul><li><strong>Dimensions</strong>: 15" x 9"</li><li>Elegant white and gold color scheme</li><li>Rectangular, shovel-shaped design for easy serving</li><li>Ideal for a variety of snacks and appetizers</li><li>Durable and easy to clean</li></ul><p>Make every occasion special with this stunning and versatile serving platter!</p>',
      MRP: 3499,
      sellingPrice: 2599,
      category: {
        data: {
          attributes: {
            name: "Shovel",
            slug: "shovel",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Rectangle Shovel",
            slug: "rectangle-shovel",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '15"',
            slug: "15",
          },
        },
      },
      sku: "SPSRWG15",
      code: "RB14",
      dimensions: {
        width: '9"',
        height: "",
        length: '15"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Shovel Serving Platter - White Gold Rectangle",
              url: "/images/products/Shovel_Serving_Platter_White_Gold_Rectangle1_7bf66d00fc.webp",
              size: 28.98,
            },
          },
          {
            attributes: {
              alternativeText: "Shovel Serving Platter - White Gold Rectangle0",
              url: "/images/products/Shovel_Serving_Platter_White_Gold_Rectangle_4d975c5d14.webp",
              size: 69.45,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Swirl Black Stallion",
      slug: "swirl-black-stallion",
      description:
        '<p>Enhance your space with the striking <strong>Swirl Black Stallion T-Light Holder</strong>. This unique piece features a captivating swirl design in rich black, creating an eye-catching focal point for any room.</p><p>Measuring <strong>9.5" x 9.5" x 4"</strong>, its generous size makes it perfect for displaying multiple T-lights, casting a warm and inviting glow that transforms your ambiance. The intricate swirl pattern not only adds texture but also plays beautifully with light, making it an elegant addition to your home décor.</p><p>Ideal for both modern and traditional settings, this T-light holder is perfect for cozy evenings, special occasions, or simply adding a touch of sophistication to your everyday life.</p>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Swirl",
            slug: "swirl",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black Stallion",
            slug: "black-stallion",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '9.5"',
            slug: "95",
          },
        },
      },
      sku: "SWRBIGBK",
      code: "RB32",
      dimensions: {
        width: '9.5"',
        height: '4"',
        length: '9.5"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Swirl Black Stallion0",
              url: "/images/products/Swirl_Black_Stallion_1cddf237db.webp",
              size: 92.8,
            },
          },
          {
            attributes: {
              alternativeText: "Swirl Black ",
              url: "/images/products/Swirl_Black_2nd_angle_7d789ac765.webp",
              size: 41.7,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Swirl Mini Stallion",
      slug: "swirl-mini-stallion",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="97035aa6-5805-4b59-a0ee-6236a95675f4" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Introduce a touch of elegance to your space with the <strong>Swirl Black Stallion T-Light Holder</strong>. Featuring a mesmerizing swirl design in deep black, this charming piece adds a bold yet sophisticated accent to any décor.</p><p>Measuring <strong>5.2" x 5.2" x 2.5"</strong>, its compact size makes it perfect for small tabletops, shelves, or mantels, allowing you to create a cozy atmosphere with ease. The unique swirl pattern beautifully interacts with candlelight, casting enchanting shadows and warm glows.</p><p>Ideal for both everyday use and special occasions, this T-light holder is a stylish choice for those who appreciate modern design and artistic flair.</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Swirl",
            slug: "swirl",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Mini Stallion",
            slug: "mini-stallion",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '5.2"',
            slug: "52",
          },
        },
      },
      sku: "SWRSMLBK",
      code: "RB33",
      dimensions: {
        width: '5.2"',
        height: '2.5"',
        length: '5.2"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Swirl Mini Stallion0",
              url: "/images/products/Swirl_Mini_Stallion_21c2fb9144.webp",
              size: 14.45,
            },
          },
          {
            attributes: {
              alternativeText: "Swirl Mini Stallion1",
              url: "/images/products/Swirl_Mini_Stallion_f1974654f0.webp",
              size: 14.45,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Table Clock - Stone peach",
      slug: "table-clock-stone-peach",
      description:
        "<p>Elevate your space with this stunning <strong>Handcrafted white glass with &nbsp;a unique stone embedded dial &nbsp;finish.</strong> This exquisite piece combines artistry with functionality, making it a striking addition to any room.</p><p>With a diameter of <strong>6 inches</strong> and a height of <strong>7 inches</strong>, the clock is perfectly sized for tabletops, shelves, or desks. Its delicate glass structure beautifully reflects light, while the <strong>rose gold-plated metal stand</strong> adds a touch of elegance and sophistication.</p><p>This clock is not just a timekeeper; it's a statement piece that enhances your décor while keeping you punctual. Perfect for modern homes or as a thoughtful gift, this handcrafted item embodies both beauty and practicality.</p>",
      MRP: 1950,
      sellingPrice: 1450,
      category: {
        data: {
          attributes: {
            name: "Table Clock",
            slug: "table-clock",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Stone Peach",
            slug: "stone-peach",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '6"',
            slug: "6",
          },
        },
      },
      sku: "CLCKPECH",
      code: "RB38",
      dimensions: {
        width: '6"',
        height: '8"',
        length: '6"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Table Clock - Stone peach0",
              url: "/images/products/Table_Clock_Stone_peach_32452312e8.webp",
              size: 82.49,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Table Clock Code Pink",
      slug: "table-clock-code-pink",
      description:
        "<p>Elevate your space with this stunning <strong>Handcrafted &nbsp;Fool Moon deisign Glass Table Clock</strong>. Featuring a unique design in CODE PINK &nbsp;glass. This exquisite piece combines artistry with functionality, making it a striking addition to any room.</p><p>With a diameter of <strong>6 inches</strong> and a height of <strong>7 inches</strong>, the clock is perfectly sized for tabletops, shelves, or desks. Its delicate glass structure beautifully reflects light, while the <strong>rose gold-plated metal stand</strong> adds a touch of elegance and sophistication.</p><p>This clock is not just a timekeeper; it's a statement piece that enhances your décor while keeping you punctual. Perfect for modern homes or as a thoughtful gift, this handcrafted item embodies both beauty and practicality.</p>",
      MRP: 1950,
      sellingPrice: 1450,
      category: {
        data: {
          attributes: {
            name: "Table Clock",
            slug: "table-clock",
          },
        },
      },
      stock: 3,
      color: {
        data: {
          attributes: {
            name: "Code Pink",
            slug: "code-pink",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '6"',
            slug: "6",
          },
        },
      },
      sku: "CLCKPINK",
      code: "RB36",
      dimensions: {
        width: '6"',
        height: '8"',
        length: '6"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Table Clock Code Pink0",
              url: "/images/products/Table_Clock_Code_Pink_0c5133df00.webp",
              size: 54.87,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Table Clock Full moon",
      slug: "table-clock-full-moon",
      description:
        "<p>Elevate your space with this stunning <strong>Handcrafted &nbsp;Full Moon design Glass Table Clock</strong>. Featuring a unique design in &nbsp;white and golden glass. This exquisite piece combines artistry with functionality, making it a striking addition to any room.</p><p>With a diameter of <strong>6 inches</strong> and a height of <strong>7 inches</strong>, the clock is perfectly sized for tabletops, shelves, or desks. Its delicate glass structure beautifully reflects light, while the <strong>rose gold-plated metal stand</strong> adds a touch of elegance and sophistication.</p><p>This clock is not just a timekeeper; it's a statement piece that enhances your décor while keeping you punctual. Perfect for modern homes or as a thoughtful gift, this handcrafted item embodies both beauty and practicality.</p>",
      MRP: 1950,
      sellingPrice: 1450,
      category: {
        data: {
          attributes: {
            name: "Table Clock",
            slug: "table-clock",
          },
        },
      },
      stock: 3,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '6"',
            slug: "6",
          },
        },
      },
      sku: "CLCKAUTM",
      code: "RB35",
      dimensions: {
        width: '4.5"',
        height: '7"',
        length: '6"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Table Clock Full moon0",
              url: "/images/products/Table_Clock_Full_moon_8ae51db075.webp",
              size: 66.58,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Table Clock Jubilee",
      slug: "table-clock-jubilee",
      description:
        "<p>Elevate your space with this stunning <strong>Handcrafted white glass with Chinar inspired leaf design.</strong> This exquisite piece combines artistry with functionality, making it a striking addition to any room.</p><p>With a diameter of <strong>6 inches</strong> and a height of <strong>7 inches</strong>, the clock is perfectly sized for tabletops, shelves, or desks. Its delicate glass structure beautifully reflects light, while the <strong>rose gold-plated metal stand</strong> adds a touch of elegance and sophistication.</p><p>This clock is not just a timekeeper; it's a statement piece that enhances your décor while keeping you punctual. Perfect for modern homes or as a thoughtful gift, this handcrafted item embodies both beauty and practicality.</p>",
      MRP: 1950,
      sellingPrice: 1450,
      category: {
        data: {
          attributes: {
            name: "Table Clock",
            slug: "table-clock",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Chinar",
            slug: "chinar",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '6.4"',
            slug: "64",
          },
        },
      },
      sku: "CLCKJUBIL",
      code: "RB37",
      dimensions: {
        width: '6.4"',
        height: '10.4"',
        length: '6.4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Table Clock Jubilee0",
              url: "/images/products/Table_Clock_Jubilee_e50c114229.webp",
              size: 26.36,
            },
          },
          {
            attributes: {
              alternativeText: "Table Clock Jubilee1",
              url: "/images/products/Table_Clock_Jubilee_0dc797a369.webp",
              size: 54.71,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Table Clock Spiral",
      slug: "table-clock-spiral",
      description:
        "<p>Elevate your space with this stunning <strong>Handcrafted Spiral Glass Table Clock</strong>. Featuring a unique spiral design in black gold, &nbsp;this exquisite piece combines artistry with functionality, making it a striking addition to any room.</p><p>With a diameter of <strong>6 inches</strong> and a height of <strong>7 inches</strong>, the clock is perfectly sized for tabletops, shelves, or desks. Its delicate glass structure beautifully reflects light, while the <strong>rose gold-plated metal stand</strong> adds a touch of elegance and sophistication.</p><p>This clock is not just a timekeeper; it's a statement piece that enhances your décor while keeping you punctual. Perfect for modern homes or as a thoughtful gift, this handcrafted item embodies both beauty and practicality.</p>",
      MRP: 1950,
      sellingPrice: 1450,
      category: {
        data: {
          attributes: {
            name: "Table Clock",
            slug: "table-clock",
          },
        },
      },
      stock: 3,
      color: {
        data: {
          attributes: {
            name: "Spiral",
            slug: "spiral",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '6"',
            slug: "6",
          },
        },
      },
      sku: "CLCKSPIR",
      code: "RB34",
      dimensions: {
        width: '4.5"',
        height: '7.5"',
        length: '6"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Table Clock Black Gold",
              url: "/images/products/Table_Clock_Black_Gold_4e039abd9e.webp",
              size: 48.25,
            },
          },
          {
            attributes: {
              alternativeText: "Table Clock Spiral0",
              url: "/images/products/Table_Clock_Spiral_5aa5ac7de0.webp",
              size: 52.77,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Amber",
      slug: "tulip-amber",
      description:
        '<p>Bring a warm and inviting glow to your space with the <strong>Tulip Amber Glass T-Light Holder</strong>. This beautifully crafted piece features a <strong>unique artistic shape</strong> inspired by the graceful form of a tulip, adding a touch of elegance to any room.</p><p>The rich <strong>amber glass</strong> finish creates a stunning effect when illuminated, casting a soft, golden light that enhances the ambiance of your home. Perfect for cozy evenings or stylish gatherings, this T-light holder is as functional as it is decorative.</p><p>Measuring 10.8" x 10.8" x 6.8", its distinctive design makes it an eye-catching centerpiece for dining tables, shelves, or mantelpieces, offering both contemporary charm and artistic sophistication. A perfect addition for those</p>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Brown",
            slug: "brown",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '10.8"',
            slug: "108",
          },
        },
      },
      sku: "TLPBIGBR",
      code: "RB23",
      dimensions: {
        width: '10.8"',
        height: '6.8"',
        length: '10.8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Amber0",
              url: "/images/products/Tulip_Amber_f9c18d3eca.webp",
              size: 111.02,
            },
          },
          {
            attributes: {
              alternativeText: "Tulip Amber1",
              url: "/images/products/Tulip_Amber_65e907b19d.webp",
              size: 72.95,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Black Knight",
      slug: "tulip-black-knight",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="373c83e1-a412-4f9e-9e53-67bb1f7d911e" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Enhance your space with the sophisticated elegance of the <strong>Tulip Black Knight Glass T-Light Holder</strong>. Uniquely shaped with an artistic flair, this beautiful piece combines modern design with timeless charm, making it a standout addition to any setting.</p><p>Crafted from high-quality glass, the <strong>Tulip Black Knight</strong> features a sleek black finish that radiates a subtle glow when a T-light is placed inside. Its tulip-inspired silhouette offers a graceful and stylish look, perfect for creating a warm, inviting ambiance.</p><p>Measuring 10.8" x 10.8" x 6.8", this T-light holder is ideal for accentuating dining tables, mantelpieces, or living spaces with its blend of functionality and artistic appeal. Perfect for those who appreciate bold yet elegant design.</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black",
            slug: "black",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '10.8"',
            slug: "108",
          },
        },
      },
      sku: "TLPBIGBK",
      code: "RB22",
      dimensions: {
        width: '10.8"',
        height: '6.8"',
        length: '10.8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: null,
              url: "/images/products/pixelcut_export_60_ee9fc6ab6c.jpeg",
              size: 489.27,
            },
          },
          {
            attributes: {
              alternativeText: "Tulip Black Knight1",
              url: "/images/products/Tulip_Black_Knight_87e2296d1d.webp",
              size: 21.72,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Clear",
      slug: "tulip-clear",
      description:
        '<p>The <strong>Tulip Clear Glass T-Light Holder</strong> is a perfect blend of simplicity and elegance. Crafted from high-quality <strong>clear glass</strong> in a tulip-inspired shape, this holder adds a touch of refined beauty to any space. Its transparent design allows the warm glow of candlelight to shine through, creating a serene and inviting ambiance.</p><p>Compact at <strong>4" x 4" x 2.8"</strong>, this versatile T-light holder is ideal for accenting small spaces like shelves, tables, or mantels. Whether for everyday décor or special</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Clear Gold",
            slug: "clear-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '4"',
            slug: "4",
          },
        },
      },
      sku: "TLPSMLCR",
      code: "RB30",
      dimensions: {
        width: '4"',
        height: '2.8"',
        length: '4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Clear0",
              url: "/images/products/Tulip_Clear_c67bfa4efa.webp",
              size: 89.41,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Crystal",
      slug: "tulip-crystal",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="a4d5eb26-c7da-4f89-b3a0-3dad314a1313" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Add timeless elegance to your home with the <strong>Tulip Clear Glass T-Light Holder</strong> featuring <strong>golden edging</strong>. Designed in a <strong>unique artistic tulip shape</strong>, this piece beautifully combines the clarity of glass with luxurious gold accents, offering a sophisticated and radiant look.</p><p>When lit, the clear glass softly diffuses the candlelight, while the golden edging adds a touch of opulence, making it a stunning decorative centerpiece. Perfect for intimate settings or stylish gatherings, this T-light holder exudes both simplicity and grace.</p><p>With dimensions of 10.8" x 10.8" x 6.8", it serves as a refined accent for dining tables, mantelpieces, or shelves, creating a warm, elegant ambiance in any space. This piece is ideal for those who appreciate subtle luxury and artistic design.</p></div></div></div></div>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Crystal",
            slug: "crystal",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '10.8"',
            slug: "108",
          },
        },
      },
      sku: "TLPBIGCR",
      code: "RB25",
      dimensions: {
        width: '10.8"',
        height: '6.8"',
        length: '10.8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Crystal0",
              url: "/images/products/Tulip_Crystal_ed7a511ac0.webp",
              size: 51.3,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Ebony",
      slug: "tulip-ebony",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="a8f82c6a-393f-4f3f-bf32-4526b9d032c2" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>mbrace modern sophistication with the <strong>Tulip Ebony T-Light Holder</strong>, crafted from sleek black glass in a stylish <strong>tulip-inspired shape</strong>. Compact yet striking, this elegant piece brings a contemporary edge to your décor, perfect for creating a dramatic ambiance.</p><p>The deep <strong>ebony black glass</strong> enhances the soft flicker of candlelight, making it an ideal accent for intimate gatherings, cozy nights, or as a chic decorative element in any room. Its minimalist design adds a touch of class and refinement to your living space.</p><p>Measuring 4" x 4" x 2.8", this compact T-light holder is perfect for tabletops, shelves, or mantels, offering a subtle yet artistic way to enhance your home’s atmosphere. Ideal for those who appreciate modern design with a touch of understated elegance.</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Black",
            slug: "black",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '4"',
            slug: "4",
          },
        },
      },
      sku: "TLPSMLBK",
      code: "RB27",
      dimensions: {
        width: '4"',
        height: '2.8"',
        length: '4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Ebony0",
              url: "/images/products/Tulip_Ebony_bb06af42d8.webp",
              size: 29.92,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Emerald",
      slug: "tulip-emerald",
      description:
        '<p>Add a splash of color and elegance to your décor with the <strong>Tulip Emerald Green T-Light Holder</strong>. Crafted from exquisite <strong>emerald green glass</strong>, this T-light holder features a delicate tulip-inspired design that brings both beauty and modern charm to any setting.</p><p>The deep green glass softly diffuses the candlelight, creating a soothing, ambient glow perfect for cozy evenings or enhancing your living space with a touch of sophistication. Measuring <strong>4" x 4" x 2.8"</strong>, this compact holder is an ideal accent for tabletops, shelves, or mantels, offering both function and aesthetic appeal.</p><p>Perfect for those who love vibrant color and elegant design, this T-light holder is a stylish addition to any home.</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Green",
            slug: "green",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '4"',
            slug: "4",
          },
        },
      },
      sku: "TLPSMLGR",
      code: "RB29",
      dimensions: {
        width: '4"',
        height: '2.8"',
        length: '4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Emerald0",
              url: "/images/products/Tulip_Emerald_9796664cc0.webp",
              size: 83.61,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Mocha",
      slug: "tulip-mocha",
      description:
        '<p>Introduce warmth and elegance to your space with the <strong>Tulip Mocha T-Light Holder</strong>, crafted from rich <strong>brown glass</strong>. Inspired by the graceful curves of a tulip, this T-light holder combines modern design with a cozy, earthy aesthetic.</p><p>The soft mocha hue of the glass casts a soothing, ambient glow when lit, making it ideal for creating a relaxed and inviting atmosphere. Measuring <strong>4" x 4" x 2.8"</strong>, this compact holder is perfect for accenting smaller spaces like coffee tables, shelves, or mantels, adding a stylish yet functional touch to your home décor.</p><p>This T-light holder is perfect for those who love subtle elegance with a touch of warmth.</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Mocha",
            slug: "mocha",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '4"',
            slug: "4",
          },
        },
      },
      sku: "TLPSMLBR",
      code: "RB28",
      dimensions: {
        width: '4"',
        height: '2.8"',
        length: '4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "brown tulip set of 2",
              url: "/images/products/brown_tulip_set_of_2_a0ecc04acf.webp",
              size: 49.85,
            },
          },
          {
            attributes: {
              alternativeText: "Tulip Mocha0",
              url: "/images/products/Tulip_Mocha_5e52ea97ae.webp",
              size: 83.48,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Sapphire",
      slug: "tulip-sapphire",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="065f538e-fef0-4e9e-9391-48a3272cb595" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Elevate your décor with the stunning <strong>Tulip Sapphire Glass T-Light Holder</strong> featuring <strong>golden edging</strong>. Designed with a <strong>unique artistic tulip shape</strong>, this piece captures the deep, rich hue of sapphire, complemented by elegant gold accents along the edges.</p><p>The sapphire glass creates a mesmerizing glow when illuminated, while the golden edging adds a touch of luxury and sophistication. Perfect for enhancing both modern and traditional settings, this T-light holder brings a sense of opulence and serenity to your space.</p><p>Measuring 10.8" x 10.8" x 6.8", this beautiful T-light holder is ideal for accenting tables, mantelpieces, or shelves, creating a refined and stylish ambiance. It\'s the perfect decorative piece for those who love a blend of rich color, artistic design, and elegance.</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Blue",
            slug: "blue",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '10.8"',
            slug: "108",
          },
        },
      },
      sku: "TLPBIGBL",
      code: "RB26",
      dimensions: {
        width: '10.8"',
        height: '6.8"',
        length: '10.8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Blue Tulip Big andgle 2",
              url: "/images/products/Blue_Tulip_Big_andgle_2_b898fdd518.webp",
              size: 53.54,
            },
          },
          {
            attributes: {
              alternativeText: "Blue Tulip Big",
              url: "/images/products/Blue_Tulip_Big_75dbdbbea9.webp",
              size: 50.49,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Small Blue",
      slug: "tulip-small-blue",
      description:
        '<div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="16eac19a-6b38-4092-a186-de8f5b5ce709" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Illuminate your space with the vibrant charm of the <strong>Tulip Blue Glass T-Light Holder</strong>. This beautifully designed holder features a stunning blue glass in a graceful tulip shape, bringing a pop of color and elegance to your décor.</p><p>When lit, the blue glass casts a calming, ambient glow, perfect for creating a cozy atmosphere in any setting. Measuring <strong>4" x 4" x 2.8"</strong>, it’s an ideal size for accenting tables, shelves, or mantels, making it a versatile addition to your home.</p><p>This T-light holder is perfect for those who appreciate a blend of artistic design and functional beauty, adding a touch of serenity and style to your living space.</p></div></div></div></div><p>&nbsp;</p>',
      MRP: 850,
      sellingPrice: 650,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Blue",
            slug: "blue",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '4"',
            slug: "4",
          },
        },
      },
      sku: "TLPSMLBL",
      code: "RB31",
      dimensions: {
        width: '4"',
        height: '2.8"',
        length: '4"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Tulip Small Blue0",
              url: "/images/products/Tulip_Small_Blue_8353c71e32.webp",
              size: 60.9,
            },
          },
          {
            attributes: {
              alternativeText: "Tulip Small Blue1",
              url: "/images/products/Tulip_Small_Blue_8d722c4065.webp",
              size: 60.9,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Tulip Spring Green",
      slug: "tulip-spring-green",
      description:
        '<div class="flex-1 overflow-hidden"><div class="h-full"><div class="react-scroll-to-bottom--css-hyoed-79elbk h-full"><div class="react-scroll-to-bottom--css-hyoed-1n7m0yu"><div class="flex flex-col text-sm md:pb-9"><article class="w-full text-token-text-primary focus-visible:outline-2 focus-visible:outline-offset-[-4px]" dir="auto" data-testid="conversation-turn-13" data-scroll-anchor="true"><div class="text-base py-[18px] px-3 md:px-4 m-auto w-full md:px-5 lg:px-4 xl:px-5"><div class="mx-auto flex flex-1 gap-4 text-base md:gap-5 lg:gap-6 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem]"><div class="group/conversation-turn relative flex w-full min-w-0 flex-col agent-turn"><div class="flex-col gap-1 md:gap-3"><div class="flex max-w-full flex-col flex-grow"><div class="min-h-[20px] text-message flex w-full flex-col items-end gap-2 whitespace-normal break-words [.text-message+&amp;]:mt-5" data-message-author-role="assistant" data-message-id="f65e7e9d-08cc-434c-9aed-0d11d168b6e1" dir="auto"><div class="flex w-full flex-col gap-1 empty:hidden first:pt-[3px]"><div class="markdown prose w-full break-words dark:prose-invert light"><p>Brighten your space with the refreshing charm of the <strong>Tulip Spring Green Glass T-Light Holder</strong>. This exquisite piece features a <strong>unique, tulip-inspired shape</strong>, combining artistry with elegance to create a stunning decorative accent.</p><p>Crafted from premium glass with a vibrant <strong>spring green</strong> finish, this T-light holder radiates a soft, calming glow when lit, evoking the beauty of fresh spring days. Its artistic design brings a contemporary touch to any space, perfect for adding warmth and style.</p><p>With dimensions of 10.8" x 10.8" x 6.8", this T-light holder is ideal for enhancing tabletops, mantelpieces, or living spaces with a splash of color and sophistication. It\'s a perfect choice for those seeking a unique and stylish accent for their home.</p></div></div></div></div></div></div></div></div></article></div></div></div></div></div><p>&nbsp;</p>',
      MRP: 2199,
      sellingPrice: 1750,
      category: {
        data: {
          attributes: {
            name: "Tulip",
            slug: "tulip",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "Green",
            slug: "green",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '10.8"',
            slug: "108",
          },
        },
      },
      sku: "TLPBIGGR",
      code: "RB24",
      dimensions: {
        width: '10.8"',
        height: '6.8"',
        length: '10.8"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "green tulip big",
              url: "/images/products/green_tulip_big_491f589f8a.webp",
              size: 62.4,
            },
          },
          {
            attributes: {
              alternativeText: "Tulip Spring Green1",
              url: "/images/products/Tulip_Spring_Green_7d7ea25d20.webp",
              size: 91.85,
            },
          },
        ],
      },
    },
  },
  {
    attributes: {
      name: "Wave Platter - White Gold",
      slug: "wave-platter-white-gold",
      description:
        "<p>Elevate your dining and décor with this exquisite <strong>Wave Platter</strong> crafted from premium glass and finished in a sophisticated <strong>white gold color</strong>. Measuring <strong>17x12 inches</strong>, this elegant piece combines modern design with timeless luxury. The wave-like contour offers a sleek, flowing aesthetic that makes it ideal for displaying appetizers, desserts, or as a standalone decorative centerpiece. The subtle shimmer of the white gold finish adds a touch of opulence, perfect for enhancing both everyday meals and special occasions. Whether used for serving or décor, this platter is sure to captivate attention.</p>",
      MRP: 2999,
      sellingPrice: 2300,
      category: {
        data: {
          attributes: {
            name: "Platter",
            slug: "platter",
          },
        },
      },
      stock: 2,
      color: {
        data: {
          attributes: {
            name: "White Gold",
            slug: "white-gold",
          },
        },
      },
      size: {
        data: {
          attributes: {
            name: '17"',
            slug: "17",
          },
        },
      },
      sku: "WPWG",
      code: "RB16",
      dimensions: {
        width: '12"',
        height: '1"',
        length: '17"',
      },
      images: {
        data: [
          {
            attributes: {
              alternativeText: "Wave Platter - White Gold0",
              url: "/images/products/Wave_Platter_White_Gold_835990f8c0.webp",
              size: 83.56,
            },
          },
        ],
      },
    },
  },
];
